export enum ReviewOrderMessage {
	DiscountExcludedNote = 'DiscountExcludedNote',
}
